export enum ReleaseType {
  production = 'production',
  development = 'development',
  unitTest = 'unitTest'
}
